import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";

// Current map bearing in degrees, kept in sync with leaflet-rotate.
export const useMapBearing = (map) => {
  const [bearing, setBearing] = useState(() => map?.getBearing() ?? 0);

  useEffect(() => {
    if (!map) return;
    const onRotate = () => setBearing(map.getBearing());
    map.on("rotate", onRotate);
    return () => map.off("rotate", onRotate);
  }, [map]);

  return bearing;
};

// North indicator. Follows the map bearing and toggles the rotation dial.
export const NorthIndicator = ({ map, onClick }) => {
  const bearing = useMapBearing(map);

  return (
    <button
      type="button"
      className="north-indicator"
      title="Rotate map (N)"
      aria-label="Rotate map"
      onClick={onClick}
    >
      <svg
        viewBox="0 0 48 48"
        width="42"
        height="42"
        style={{ transform: `rotate(${bearing}deg)` }}
      >
        <circle
          cx="24"
          cy="24"
          r="22"
          fill="rgba(255, 255, 255, 0.5)"
          stroke="rgba(24, 68, 86, 0.15)"
          strokeWidth="1"
        />
        <polygon
          points="24,15 19,29 29,29"
          fill="#d6301a"
          stroke="#ffffff"
          strokeWidth="0.8"
        />
        <polygon
          points="24,41 19,29 29,29"
          fill="#5a636b"
          stroke="#ffffff"
          strokeWidth="0.8"
        />
        <text
          x="24"
          y="12.5"
          textAnchor="middle"
          fontSize="9"
          fontWeight="800"
          fill="#0f2d3a"
          stroke="#ffffff"
          strokeWidth="1.4"
          paintOrder="stroke"
        >
          N
        </text>
      </svg>
    </button>
  );
};

NorthIndicator.propTypes = {
  map: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};
